import React, { useRef, useEffect } from "react";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";

const CommonMap = ({ center, routePath = [], zoom = 17 }) => {
  const mapRef = useRef(null);

  const handleMapLoad = (map) => {
    mapRef.current = map;
  };

  useEffect(() => {
    if (!mapRef.current) return;

    const bounds = new window.google.maps.LatLngBounds();

    if (routePath.length > 0) {
      routePath.forEach((point) => {
        bounds.extend(point);
      });
    }

    if (center?.lat && center?.lng) {
      bounds.extend(center);
    }

    if (!bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds);
    }
  }, [routePath, center]);

  return (
    <GoogleMap
      onLoad={handleMapLoad}
      mapContainerStyle={{
        width: "100%",
        height: "100%",
      }}
      center={center}
      zoom={zoom}
    >
      {/* Route Line */}
      {routePath.length > 1 && (
        <Polyline
          path={routePath}
          options={{
            strokeColor: "#2563eb",
            strokeWeight: 5,
            strokeOpacity: 1,
          }}
        />
      )}

      {/* Alarm Point (Blue Marker) */}
      {center && (
        <Marker
          position={center}
          icon={{
            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          }}
        />
      )}

      {/* Start Marker */}
      {routePath.length > 0 && (
        <Marker
          position={routePath[0]}
          label={{
            text: "S",
            color: "#ffffff",
            fontWeight: "bold",
          }}
        />
      )}

      {/* End Marker */}
      {routePath.length > 1 && (
        <Marker
          position={routePath[routePath.length - 1]}
          label={{
            text: "E",
            color: "#ffffff",
            fontWeight: "bold",
          }}
        />
      )}
    </GoogleMap>
  );
};

export default CommonMap;